import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Avatar from '@material-ui/core/Avatar';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import MaterialTable from 'material-table';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';

import UserInteractionProfile from '../UserInteractionProfile';
import { Table } from 'components';

const styles = theme => ({
  displayName: {
    display: 'flex',
    alignItems: 'center',
  },
  avatar: {
    marginRight: 10,
  },
  tableContainer: {
    '& table:first-child': {
      '& tr': {
        '& td:first-child, th:first-child': {
          backgroundColor: '#ffffff',
          position: 'sticky',
          left: 0,
          zIndex: 11,
        },
        '& th:first-child': {
          zIndex: 11,
        },
      },
    },
  },
  paper: {
    color: theme.palette.text.secondary,
    marginBottom: 24,
    display: 'flex',
    flexDirection: 'column',
    padding: 15,
  },
  entriesDataTitle: {
    fontSize: 18,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  entriesStartedValue: {
    color: '#FF3B00',
    fontSize: 40,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  entriesCompletedValue: {
    color: '#00BC2B',
    fontSize: 40,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  entriesDataSubValue: {
    color: '#000000',
    fontSize: 18,
    marginLeft: 15,
  },
});

class PicksAnalytics extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      userProfileDialog: true,
      userData: null,
    };
  }

  closeUserProfileDialog = event => {
    this.setState({
      userProfileDialog: false,
      userData: null,
    });
  };

  openUserProfileDialog = rowData => {
    this.setState({
      userProfileDialog: true,
      userData: rowData,
    });
  };
  render() {
    let {
      classes,
      interaction,
      entriesStarted,
      entriesCompleted,
      entriesCompletedPercentage,
    } = this.props;

    const pageSize = 5;

    this.columns = [
      {
        title: 'User',
        field: 'name',
        render: rowData => {
          const name = rowData.name ? rowData.name : 'Anonymous user';
          return (
            <div className={classes.displayName}>
              <Avatar className={classes.avatar} src={rowData.profile_pic}>
                <PersonOutlineOutlinedIcon />
              </Avatar>
              {name}
            </div>
          );
        },
      },
      { title: 'Email', field: 'email' },
    ];
    this.props.columnMaterialTable.forEach(column => {
      if (column.columnType === 'question') {
        column.render = rowData => {
          const questionColumnData = rowData[column.index];

          if (questionColumnData) {
            const color = questionColumnData.userAnswerCorrect ? 'green' : 'red';
            return <div style={{ color: color }}>{questionColumnData.text}</div>;
          } else {
            return null;
          }
        };
      }
    });

    const generalColumn = [...this.columns, ...this.props.columnMaterialTable];

    return (
      <React.Fragment>
        <Paper className={classes.paper} elevation={0}>
          <Grid container>
            <Grid item xs={12}>
              <Typography className={classes.subtitle} variant="subtitle1" gutterBottom>
                {interaction.name}
              </Typography>
            </Grid>
            <Grid item xs={3} />
            <Grid item xs={3}>
              <div className={classes.entriesStartedValue}>{entriesStarted}</div>
              <div className={classes.entriesDataTitle}>Entries started</div>
            </Grid>
            <Grid item xs={3}>
              <div className={classes.entriesCompletedValue}>
                {entriesCompleted}
                <span className={classes.entriesDataSubValue}>
                  {entriesCompletedPercentage}%
                </span>
              </div>
              <div className={classes.entriesDataTitle}>Entries completed</div>
            </Grid>
          </Grid>
        </Paper>
        <div className={classes.tableContainer}>
          <Table
            columns={generalColumn}
            data={this.props.picksData}
            title="Users"
            rowStyle={() => ({ cursor: 'pointer' })}
            onRowClick={this.openUserProfileDialog}
          />
          {this.state.userData && (
            <UserInteractionProfile
              userData={this.state.userData}
              open={this.state.userProfileDialog}
              onClose={this.closeUserProfileDialog}
            />
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(PicksAnalytics);
